// eslint-disable-next-line no-shadow
export enum RouterPathes {
  home = '/',
  offerCheckout = '/offer-checkout',
  checkoutSuccess = '/checkout/success',
  checkoutCancel = '/checkout/cancel',
}
